import { insuranceApiWithKey } from "../axios";
import {
  insuranceApiURL,
  insuranceValueApi,
  insuranceContractApi,
} from "../endpoints";
import useUserStore from "../../storeModules/useUserStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import useInsuranceStore from "../../storeModules/useInsuranceStore";
import {
  categoryNamesInsure,
  tipoPlanoInsure,
  tipoPessoaInsure,
} from "../../utils/constants";
import removeSpecialCharacters from "../../utils/removeSpecialCharacters";
import dayjs from "dayjs";
import { getClientIp } from "../requests";

const getInsuranceValue = async () => {
  const url = new URL(`${insuranceApiURL}${insuranceValueApi}`);

  const { nascimentoFundacao, cpfCnpj, tipoPessoa } =
    useUserStore.getState().contrato;

  const { categoriaId, tipoPlano } = useConsorcioStore.getState();

  const { bemCredito, planoValorParcela, planoMeses, grupo } =
    useConsorcioStore.getState().selectedPlano;

  const [day, month, year] = nascimentoFundacao
    ? nascimentoFundacao.split("/")
    : [0, 0, 0];
  const dateToDayJs = `${month}/${day}/${year}`;

  const props = {
    perfil: {
      cpf: removeSpecialCharacters(cpfCnpj),
      dataNascimento: dayjs(dateToDayJs).format("YYYY-MM-DD"),
      tipoConsorcio: categoryNamesInsure[categoriaId],
      tipoPerfil: tipoPessoaInsure[tipoPessoa],
    },
    bem: {
      valorBem: Number(bemCredito),
      valorParcela: Number(planoValorParcela),
      tipoPlano: tipoPlanoInsure[tipoPlano],
      prazoMeses: planoMeses,
      codigoGrupo: grupo,
    },
  };

  return insuranceApiWithKey.post(url, props);
};

const createInsuranceContract = async (contrato) => {
  const url = new URL(`${insuranceApiURL}${insuranceContractApi}`);

  const { idCotacao, termsVersion, termsAcceptDate, isInsuranceHired } =
    useInsuranceStore.getState();
  const clientIp = await getClientIp();

  const props = {
    cotacaoId: idCotacao,
    numeroProposta: Number(contrato),
    dadosAceite: {
      versaoRegulamento: termsVersion,
      dataHoraAceite: termsAcceptDate,
      ipCliente: clientIp,
      aceito: isInsuranceHired,
    },
  };

  return insuranceApiWithKey
    .post(url, props)
    .then((response) => {
      const { data } = response;
      console.log("Contrato do seguro gerado com sucesso!");
      console.log("Detalhes do contrato:");
      console.table(data);
    })
    .catch((error) => {
      console.log("error --->", error);
    });
};

export { getInsuranceValue, createInsuranceContract };
